// import React from 'react'

// export default function Div(props) {
//   return (
//     <div {...props}>{props.children}</div>
//   )
// }

// src/components/Div.jsx
// src/components/Div.jsx
import React, { forwardRef } from 'react';

const Div = forwardRef(({ children, ...rest }, ref) => {
  return (
    <div ref={ref} {...rest}>
      {children}
    </div>
  );
});

export default Div;


